module.exports = __webpack_public_path__ + "assets/media/lunch.79757164.mp3";